// External
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal
import { getDataTestId } from "../functions/data-test-ids";
import { Tooltip } from "../tooltip/tooltip.jsx";

// CSS
import "./tab.css";

export const TabGroupAlignment = {
    Center: 1,
    Left: 2,
    Right: 3
}

function Tab(props) {
    const onChange = () => {
        if (typeof props.OnChange === "function") {
            props.OnChange(props.Value);
        }
    };

    const getClassName = () => {
        if (props.Active) {
            return "eone-ui-tab-active";
        } else {
            return "eone-ui-tab"
        }
    };

    return (
        <button type="button" className={getClassName()} data-testid={getDataTestId(props.DataTestId, props.Value)} onClick={onChange}>
            {props.Icon && <FontAwesomeIcon icon={props.Icon} />}
            <div>{props.Label}</div>
            <TabBadge Text={props.BadgeText} />
            <Tooltip
                Title={props.TooltipTitle || props.Label}
                Tooltip={props.Tooltip}
                DataTestId={props.DataTestId} />
        </button>
    );
}

function TabBadge(props) {
    if (!props.Text) {
        return;
    }

    return (
        <div className="eone-ui-tab-badge">{props.Text}</div>
    );
}

function TabGroup(props) {
    const onChange = (value) => {
        if (typeof props.OnChange === "function") {
            props.OnChange(value);
        }
    };

    const getTabExtraContent = () => {
        return props.ExtraContent
    }

    const getTabs = () => {
        return props.Tabs.map((tab, index) => {
            if (tab.Visible === undefined || tab.Visible === true) {
                return (
                    <Tab
                        key={index}
                        Value={tab.Value}
                        Label={tab.Label}
                        Icon={tab.Icon}
                        BadgeText={tab.BadgeText}
                        Active={tab.Value === props.Value}
                        OnChange={onChange}
                        Tooltip={tab.Tooltip}
                        DataTestId={props.DataTestId} />
                );
            }
        });
    };

    const getAlignment = () => {
        switch (props.Alignment) {
            case TabGroupAlignment.Left:
                return "flex-start";
            case TabGroupAlignment.Right:
                return "flex-end";
            case TabGroupAlignment.Center:
                return "center";
        }
    };

    const getStyle = () => {
        let style = {};
        if (props.Width) {
            style.width = props.Width;
        }
        if (props.Alignment) {
            style.justifyContent = getAlignment();
        }
        if(props.SpaceUnder) {
            style.marginBottom = 20
        }
        return style;
    };
    
    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    return (
        <div className="eone-ui-tab-group-container">
            <div className="eone-ui-tab-group" style={getStyle()}>
                {getTabs()}
            </div>
            {getTabExtraContent()}
        </div>
    );
}

export { TabGroup }